import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette } : Theme) => createStyles({
  table: {
    display: 'grid',
    gridTemplateColumns: '220px 110px 170px 130px',
    fontSize: 16,
    color: palette.text.primary,
    padding: 0,
    overflowX: 'auto',
    marginBottom: 24,
  },
  tableItem: {
    padding: '8px 0',
  },
  label: {
    marginBottom: 8,
    fontSize: 12,
    fontFamily: 'Roboto',
    color: palette.text.secondary,
  },
  sectionHeader: {
    fontSize: '16px',
    fontWeight: 'bold',
    padding: '0px',
    margin: '0px'
  },
  amount: {
    color: palette.text.secondary,
  },
  invoiceCreateForm: {
    // overflowY: 'auto',
    overflowX: 'unset',
  },
  invoiceModal: {
    maxWidth: 944,
    overflowY: 'unset',
    maxHeight: 'calc(100% - 30px)',
  },
  invoiceCreateFormContainer: {
    width: '100%',
  },
  formInvoice: {
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '0.4em',
      height: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,0.28)',
      borderRadius: 5,
    },
  },
}));

export default useStyles;
